









import Vue, { PropType } from 'vue';
import Button from '../Button/Button.vue';
import { ButtonTypes, ButtonSizes } from '../Button/Button.types';
import Icon from '../../../basic/Icon.vue';

export default Vue.extend({
  name: 'icon-button',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<ButtonTypes>,
    },
    size: {
      type: String as PropType<ButtonSizes>,
    },
    label: {
      type: String,
    },
    iconName: {
      type: String,
      required: true,
    },
    rounded: {
      type: Boolean,
    },
  },
  computed: {
    iconSize() {
      if (this.size === 'small') { return 14; }
      return 18;
    },
  },
  components: {
    Button,
    Icon,
  },
});
